import { render, staticRenderFns } from "./StartupListFilters.vue?vue&type=template&id=20f8f691&scoped=true&"
import script from "./StartupListFilters.vue?vue&type=script&lang=js&"
export * from "./StartupListFilters.vue?vue&type=script&lang=js&"
import style0 from "./StartupListFilters.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StartupListFilters.vue?vue&type=style&index=1&id=20f8f691&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8f691",
  null
  
)

export default component.exports